var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { AuthProvider } from "../contexts/AuthProvider";
import { api } from '../services/api';
import cookies from '../services/cookies';
import MyRoutes from "../routes/MyRoutes";
import { LayoutProvider } from "../contexts/LayoutProvider";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "../config/queryClient";
function App() {
    if (cookies.get('token'))
        api.defaults.headers.common['Authorization'] = 'Bearer ' + cookies.get('token');
    return (_jsx(_Fragment, { children: _jsx(QueryClientProvider, __assign({ client: queryClient }, { children: _jsx(BrowserRouter, { children: _jsx(AuthProvider, { children: _jsx(LayoutProvider, { children: _jsx(MyRoutes, {}) }) }) }) })) }));
}
export default App;
